<div class="upload_container">
    <div>
        <p>Adicione aqui qualquer informação pertinente <br> a conclusão realizada no comitê - PDF/JPG/PNG</p>
        <label for="add-file" class="add_btn">+</label>
        <input type="file" id="add-file" (change)="saveAttachment($event)">
    </div>
    <div class="files">
        <div *ngFor="let file of files">
            <a [href]="file.fileName" target="_blank" class="link">{{file?.file}}</a>
            <button (click)="onRemoveFile(file.id)">X</button>
        </div>
    </div>
</div>